































import {Component, Vue} from 'vue-property-decorator'
import store from 'store'
import Modal from '@/components/common/Modal.vue'

@Component({
    components: {
        Modal,
    },
})

export default class HomeScreenWarningModal extends Vue {}
